
import WhyBodeHeroSection from '@/components/page-specific/why-bode/hero-section';
import WhyBodeDescriptionSection from '@/components/page-specific/why-bode/description-section';
import WhyBodeListSection from '@/components/page-specific/why-bode/list-section';
import WhyBodeImageSection from '@/components/page-specific/why-bode/image-section';
import WhyBodeFooterSection from '@/components/page-specific/why-bode/footer-section';
import { getAction, SET_CONTENT_DATA } from '@/store/why-bode/actions';
import WhyBodeStoreName from '@/store/why-bode/name';
import { PrismicLayoutType } from '@/constants/prismicContent';
import routes from '@/constants/routes';
import headMeta from '@/constants/headMeta';

export default {
  name: 'WhyBodePage',
  components: {
    WhyBodeHeroSection,
    WhyBodeDescriptionSection,
    WhyBodeListSection,
    WhyBodeImageSection,
    WhyBodeFooterSection,
  },
  data() {
    return {
      meta: {
        title: null,
        description: null,
      },
    };
  },
  async fetch() {
    if (this.isContentLoaded) {
      return;
    }

    const { data } = await this.getContent();

    this.meta.title = data.meta_title;
    this.meta.description = data.meta_description;

    await this.$store.dispatch(getAction(SET_CONTENT_DATA), data);
  },
  head() {
    return {
      title: this.meta.title,
      meta: [
        { hid: 'description', name: 'description', content: this.meta.description },
        { property: 'og:title', content: this.meta.title },
        { property: 'og:description', content: this.meta.description },
        { property: 'og:url', content: `${headMeta.domain}${routes.whyBode}` },
        { property: 'og:site_name', content: headMeta.siteName },
        { property: 'og:type', content: headMeta.type },
      ],
    };
  },
  computed: {
    isContentLoaded() {
      return this.$store.state[WhyBodeStoreName].isContentLoaded;
    },
  },
  methods: {
    getContent() {
      return this.$prismic.client.getSingle(PrismicLayoutType.WhyBode);
    },
  },
};
